"use client";

import Link from "next/link";
import {ArrowRight} from "lucide-react";
import {SectionHeading} from "@/components/landing/section-heading";
import {PricingPlans, usePricingPlans} from "@/components/landing/pricing-plans";

export default function Pricing({businessType}) {
    const plans = usePricingPlans();

    if (plans.length === 0) {
        return null;
    }

    return (
        <section className="bg-[#efecea] py-16 md:py-24">
            <div className="max-w-7xl mx-auto sm:px-2 lg:px-4">
                <SectionHeading
                    title="Pricing"
                    description={`Simple pricing for ${businessType.name}. No commission on your bookings. Cancel anytime.`}
                    className="items-center text-center px-4 pb-12"
                />
                <PricingPlans plans={plans} location="business_type_page" compact/>
                <div className="mt-10 flex justify-center px-4">
                    <Link
                        href="/pricing"
                        className="border-fe-primary/60 text-md hover:text-fe-primary inline-flex items-center gap-2 border-b-2 pb-0.5 font-medium text-neutral-900 transition-colors"
                    >
                        Compare all plans
                        <ArrowRight className="size-4" aria-hidden="true"/>
                    </Link>
                </div>
            </div>
        </section>
    );
}
